import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { Tipologia } from '../../models/tipologias.model';
import { Prioridad } from '../../models/tareas.model';

@Component({
    selector: 'priority-flag',
    imports:[
        MatIconModule,
        CommonModule
    ],
    template: `
        <div class="flex flex-row gap-1 items-center" >
            <mat-icon [svgIcon]="this.priority.valor2" class="icon-size-4"[ngStyle]="{'color': this.priority.valor1}"></mat-icon>
            <span>{{this.priority.descripcion}}</span>
        </div>
    `
})

export class PriorityFlagComponent implements OnInit {
    @Input() priority: Prioridad
    constructor() { }

    ngOnInit() { }
}